/**
 * Non-blocking Toast Notification Component
 * Replaces disruptive window.alert() with smooth in-app notifications.
 */

export class ToastComponent {
  private container: HTMLDivElement;
  private timeoutId: number | null = null;

  constructor() {
    this.container = document.createElement("div");
    this.container.className = "app-toast";
    this.container.setAttribute("role", "status");
    this.container.setAttribute("aria-live", "polite");
    document.body.appendChild(this.container);
  }

  public show(message: string, durationMs = 3000): void {
    if (this.timeoutId !== null) {
      window.clearTimeout(this.timeoutId);
      this.timeoutId = null;
    }

    this.container.textContent = message;
    this.container.classList.add("visible");

    this.timeoutId = window.setTimeout(() => {
      this.container.classList.remove("visible");
      this.timeoutId = null;
    }, durationMs);
  }
}
